import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// More robust service worker registration
if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      // Skip service worker registration in development environment
      // unless we explicitly set a flag
      if (
        window.location.hostname === "localhost" &&
        !localStorage.getItem("enable_sw_in_dev")
      ) {
        console.log("Service Worker registration skipped in development mode");
        console.log(
          "To enable SW in dev, set localStorage.enable_sw_in_dev = true"
        );
        return;
      }

      // Register the service worker with more options
      const registration = await navigator.serviceWorker.register(
        "/upload-service-worker.js",
        {
          scope: "/", // Control all pages
          updateViaCache: "none", // Never use cached versions of the SW
        }
      );

      console.log(
        "ServiceWorker registration successful with scope:",
        registration.scope
      );

      // Set up an interval to check for updates
      setInterval(async () => {
        try {
          await registration.update();
        } catch (error) {
          console.error("Error updating service worker:", error);
        }
      }, 60 * 60 * 1000); // Check every hour

      // Handle service worker updates
      registration.addEventListener("updatefound", () => {
        const newWorker = registration.installing;

        if (newWorker) {
          newWorker.addEventListener("statechange", () => {
            if (
              newWorker.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              // New service worker is installed but waiting
              console.log("New service worker installed and waiting");

              // Notify the user if they want to reload to activate the new version
              if (
                confirm(
                  "A new version of this application is available. Reload now?"
                )
              ) {
                window.location.reload();
              }
            }
          });
        }
      });
    } catch (error) {
      console.error("ServiceWorker registration failed:", error);
    }
  });
}

createRoot(document.getElementById("root")!).render(<App />);
